import cx from 'classnames';
import PropTypes from 'prop-types';

const OrderTitle = ({ children, className = '' }) => {
  return (
    <h2
      className={cx(
        'mb-3',
        'u-color--ExtraDarkGray',
        'u-fs--24',
        'text-uppercase',
        className
      )}
    >
      {children}
    </h2>
  );
};

OrderTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export default OrderTitle;
